var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group",attrs:{"id":_vm.groupId}},[_c('label',{staticClass:"form-switch"},[_c('input',{attrs:{"type":"checkbox","id":_vm.inputId},domProps:{"checked":_vm.value},on:{"input":_vm.onInput}}),_c('i',{staticClass:"form-icon"}),_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }